import { visionURL } from "../../config/environment";
import Jsona from "jsona";
import JsonApiService from "../../services/jsonapiService";
import { serialize } from "../../redux/utils/jsona";
import visionCallService from "../../services/visionCallService";

const dataFormatter = new Jsona();

const userAssignmentsApiService = async () =>
  new JsonApiService("user_assignments", {
    baseUrl: `${visionURL}/api`,
    credentials: "include"
  });

export const useUserAssignments = () => {
  return {
    getUserAssignments: async ({
      page,
      sort,
      filters,
      include = [],
      fields = {}
    }) => {
      const service = await userAssignmentsApiService();
      const response = await service
        .page(page)
        .sort(sort)
        .where(filters)
        .include(include)
        .fields(fields)
        .all()
        .then(response => response.json());
      return {
        data: dataFormatter.deserialize(response),
        ...response.meta
      };
    },

    getUserAssignment: async (id, { include = [], fields = {} }) => {
      const service = await userAssignmentsApiService();
      const response = await service
        .include(include)
        .fields(fields)
        .find(id)
        .then(response => response.json());
      return {
        data: visionCallService.extractAttributes(response),
        ...response.meta
      };
    },

    createUserAssignment: async (data, { include = [], fields = {} } = {}) => {
      const service = await userAssignmentsApiService();
      const response = await service
        .include(include)
        .fields(fields)
        .create(JSON.stringify(serialize({ ...data, type: "UserAssignment" })))
        .then(response => response.json());
      return {
        data: visionCallService.extractAttributes(response),
        ...response.meta
      };
    },

    updateUserAssignment: async (
      id,
      data,
      { include = [], fields = {} } = {}
    ) => {
      const service = await userAssignmentsApiService();
      const response = await service
        .include(include)
        .fields(fields)
        .update(
          id,
          JSON.stringify(serialize({ ...data, type: "UserAssignment" }))
        )
        .then(response => response.json());
      return {
        data: dataFormatter.deserialize(response),
        ...response.meta
      };
    }
  };
};
